import React from 'react';
import { CheckCircle } from 'lucide-react';

const ThankYou = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6] p-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <div className="text-center bg-white p-12 rounded-none shadow-sm border border-black/5 max-w-md">
        <img src="/wildnet-logo.png" alt="Wildnet Technologies" className="h-6 w-auto mx-auto mb-7" />
        <div className="w-16 h-16 bg-brand rounded-full flex items-center justify-center mx-auto mb-5">
          <CheckCircle className="h-8 w-8 text-white" />
        </div>
        <h1 className="text-2xl font-medium text-[#1A231C] mb-3" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="thank-you-title">
          Assessment Complete
        </h1>
        <p className="text-[#5C665F] text-sm leading-relaxed mb-4">
          Thank you for completing the assessment. Your responses have been successfully submitted and will be reviewed by the hiring team.
        </p>
        <div className="border-t border-black/5 pt-4 mt-4">
          <p className="text-[#5C665F]/60 text-xs">
            Results are confidential and will not be shared with candidates. You may close this window.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
